<template>
  <footer class="site-footer" :aria-label="$t('footer.ariaLabel')">
    <div class="site-footer__inner">
      <div class="site-footer__rule" aria-hidden="true" />
      <p class="site-footer__copyright">
        COPYRIGHT <span class="site-footer__copymark" aria-hidden="true">©</span> ALL RIGHTS RESERVED.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'BlackGoldSiteFooter'
}
</script>
